import { DashboardNoSpenderListRestEndpointService } from '@api'
import type { PaginationState } from '@tanstack/react-table'
import { useQuery } from 'react-query'

import { handleError } from '@/utils/error'

export function useGetNoSpenderLists(
  creatorId: number,
  paginationState: PaginationState,
  searchQuery: string,
) {
  const { data, isFetching, error, isSuccess, isError, refetch } = useQuery({
    queryKey: [
      'creator',
      creatorId,
      'no-spenders',
      paginationState,
      searchQuery,
    ],
    queryFn: () =>
      DashboardNoSpenderListRestEndpointService.dashboardGetNoSpenderLists({
        creatorId,
        page: paginationState.pageIndex,
        size: paginationState.pageSize,
        name: searchQuery,
      }),
    enabled: !!creatorId,
    onError: (error) =>
      handleError(error, 'Failed to get no spender lists', refetch),
  })

  return {
    data: data?.content ?? [],
    pageCount: data?.totalPages ?? 0,
    isFetching,
    error,
    isSuccess,
    isError,
  }
}
